import {
  REMOVE_PLANS_LOADING,
  REMOVE_PLANS_SUCCESS,
  REMOVE_PLANS_FAILED,
} from "../types";
import { PlanAssignmentResponse } from "../actions/removePlansFromMerchant";

const initialState = {
  loading: false,
  data: null as PlanAssignmentResponse | null,
  error: null as string | null,
};

export const removePlansReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case REMOVE_PLANS_LOADING:
      return { ...state, loading: true, error: null };
    case REMOVE_PLANS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case REMOVE_PLANS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload ?? action.error ?? null,
      };
    case "RESET_REMOVE_PLANS":
      return initialState;
    default:
      return state;
  }
};

export const resetRemovePlans = () => ({ type: "RESET_REMOVE_PLANS" });
